import styled from 'styled-components'

import Theme from 'styles/theme'
import designTokens from 'styles/designTokens'
import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import Checklist from '../../../components/display/Checklist'
import SimpleLink from '../../../components/display/SimpleLink'
import { FixedColumnsMasonry } from '../../../components/landing/MasonryImages'

import { CallToActionButton } from '../shared'

import { masonryImages as defaultMasonryImages } from './content'

const Title = styled.h5`
  ${typeStyle('-ds-font-title-2')}
  color: ${({ theme }) => theme['-ds-core-300'].value};

  letter-spacing: unset;
  line-height: 1.3;
  font-weight: 400;
  margin: 18px 0;
`

const Paragraph = styled.p`
  ${typeStyle('-ds-font-lead-light')}
  color: ${({ theme }) => theme['-ds-neutral-700'].value};
  margin-top: 0;
`

const ChecklistWrapper = styled.div`
  margin-top: 20px;
`

const Half = styled.div`
  ${media.md`
    width: 50%;
    max-width: 550px;
  `}
`

const InfoWrapper = styled(Half)`
  display: flex;
  flex-direction: column;
  padding: 16px;

  ${media.md`
    padding-left: 64px;
  `}

  ${CallToActionButton} {
    margin: 40px auto 0;

    ${media.md`
      margin: 40px auto 0 0;
    `}
  }
`

const IllustrationWrapper = styled(Half)`
  ${media.md`
    margin-top: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    & > * {
      width: 100%;
    }
  `}
`

const Outer = styled.div`
  padding: 70px 16px 60px;
  background-color: ${({ theme }) => theme['-ds-neutral-200'].value};

  ${media.md`
    display: flex;
    flex-direction: row;
    justify-content: center;
  `}
`

const benefits = [
  {
    primaryText: 'Attract like-minded guests and regular bookings, easy peasy.',
  },
  {
    primaryText:
      'Get matched with the right storyteller to bring your property to life.',
  },
  {
    primaryText:
      'Sync your calendar with other platforms in just a few clicks.',
  },
]

type HostInfoProps = {
  masonryImages?: Array<{ large: string; medium: string }>
}

const HostInfo = ({ masonryImages = defaultMasonryImages }: HostInfoProps) => {
  return (
    <Outer>
      <IllustrationWrapper>
        <FixedColumnsMasonry
          images={masonryImages}
          columnsCount={2}
          imagesPerColumn={{
            1: 2,
            2: 2,
            3: 2,
          }}
          gutter={16}
        />
      </IllustrationWrapper>

      <InfoWrapper>
        <Title>List your property, share its story</Title>
        <Paragraph>
          Join a community of proud hosts. List your property on Riparide today
          and start accepting bookings.
        </Paragraph>

        <ChecklistWrapper>
          <Checklist
            items={benefits}
            primaryTextFontSize={designTokens['-ds-font-lead-light'].fontSize}
            primaryTextColor={Theme['-ds-neutral-700'].value}
            primaryTextFontWeight={300}
            primaryTextLineHeight={1.5}
            secondaryTextFontSize={designTokens['-ds-font-lead-light'].fontSize}
          />
        </ChecklistWrapper>

        <SimpleLink
          to={() => {
            return '/list-with-us'
          }}
          width="auto"
        >
          <CallToActionButton as="span" fullwidth={false} rounded ghost>
            Become a Riparide Host
          </CallToActionButton>
        </SimpleLink>
      </InfoWrapper>
    </Outer>
  )
}

export default HostInfo
